function LinkedNFTChip(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" {...props}>
            <g>
                <circle cx="6.5" cy="6.5" r="6.5" fill="black" fillOpacity="0.5" />
                <path
                    transform="translate(2 2)"
                    d="M5.21106 3.78895C4.60357 3.18146 3.61865 3.18146 3.01117 3.78895L1.45561 5.3445C0.848129 5.95198 0.848129 6.93691 1.45561 7.54439C2.06309 8.15187 3.04802 8.15187 3.6555 7.54439L4.08389 7.116M3.78895 5.21106C4.39643 5.81854 5.38135 5.81854 5.98883 5.21106L7.54439 3.6555C8.15187 3.04802 8.15187 2.06309 7.54439 1.45561C6.93691 0.848129 5.95198 0.848129 5.3445 1.45561L4.91687 1.88324"
                    stroke="white"
                    strokeWidth="0.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}

export default LinkedNFTChip;
